import { useFavorites } from "@/hooks/useFavorites";

interface FavoriteButtonProps {
  filmId: string;
  className?: string;
}

export default function FavoriteButton({ filmId, className = "" }: FavoriteButtonProps) {
  const { isFavorite, toggle } = useFavorites();
  const active = isFavorite(filmId);

  return (
    <button
      type="button"
      onClick={() => toggle(filmId)}
      aria-pressed={active}
      className={`inline-flex items-center justify-center gap-2 h-10 px-4 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
        active
          ? "bg-accent-500 text-background-50 hover:bg-accent-600"
          : "border border-background-300 text-foreground-800 hover:border-accent-400 hover:text-accent-600 bg-background-50"
      } ${className}`}
    >
      <i className={`${active ? "ri-bookmark-fill" : "ri-bookmark-line"} text-base`} />
      {active ? "已收藏" : "收藏"}
    </button>
  );
}